import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const restoreMedia: (
  fetchContext: FetchContext,
  questionnaireId: number,
  accessToken?: string) => Promise<void> = (fetchContext, questionnaireId, accessToken) => 
    fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}/media/restoration`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'restore media'));
